import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  GET,
  GET_FILE,
  profile,
  t,
} from "../../components/CustomComponent.js";
import {
  fill,
  fmtInt,
  fmtBaht,
  fmtBahtOrDash,
  fmtDate,
  fmtDay,
  StatusBadge,
  WarrantyBadge,
  TypeBadge,
  OpenBadge,
  EmptyBox,
  Skeleton,
  ErrorCard,
  WarrantyBars,
  TYPE_COLORS,
  TIMELINE_TYPES,
} from "../../components/AssetHistoryParts.js";
import { fmtMinutes, hasPermission } from "../../utils/timeTracking.js";
import "../../assets/css/asset-history.css";

const ACCESS_DENIED = "Access denied";

// หน้า ③ ประวัติสินทรัพย์ (Asset 360) - GET admin/asset-history-report/:uid (สิทธิ์ asset.read)
// ไฟล์ Service Report / รูป โหลดผ่าน GET_FILE -> blob URL เท่านั้น (ไม่ใช้ S3 URL ตรง)
export default class AdminAssetHistoryDetail extends Component {
  constructor(props) {
    super(props);
    this.uid = new URLSearchParams(window.location.search).get("uid") || "";
    this.canCreateWr = hasPermission(profile, "wr.create");
    this.state = {
      data: null,
      fetching: true,
      error: "",
      forbidden: false,
      not_found: false,
      type_filter: "all",
      expanded: {}, // key ของ timeline ที่ขยายอะไหล่/เอกสารอยู่
      opening_report: "", // key ที่กำลังโหลด Service Report
      gallery: null, // { title, items: [{ uid, file_name, file_type, url, failed }], loading }
      creating_wr: false,
    };
    this.blob_urls = [];
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  componentWillUnmount() {
    this.RevokeAll();
  }

  RevokeAll = () => {
    this.blob_urls.forEach((u) => URL.revokeObjectURL(u));
    this.blob_urls = [];
  };

  Get = async () => {
    if (!this.uid) {
      this.setState({ fetching: false, not_found: true });
      return;
    }
    this.setState({ fetching: true, error: "", forbidden: false, not_found: false });
    const result = await GET(`admin/asset-history-report/${encodeURIComponent(this.uid)}`, null, true, { skipAccessDeniedAlert: true });
    if (result?.status && result.data) {
      this.setState({ data: result.data, fetching: false });
      return;
    }
    const message = typeof result?.message === "string" ? result.message : "";
    this.setState({
      data: null,
      fetching: false,
      forbidden: message === ACCESS_DENIED,
      not_found: message === "Asset not found",
      error: message === ACCESS_DENIED || message === "Asset not found" ? "" : message || t("ah_error_hint"),
    });
  };

  // ---------------------------------------------------------------- actions
  OpenAssetMaster = () => {
    window.location.href = `/ad/assets?uid=${encodeURIComponent(this.uid)}`;
  };

  // "+ แจ้งซ่อม" -> /ad/work-requests?prefill=1 (หน้านั้นเปิดฟอร์มสร้างพร้อมแผนก/ลูกค้า/เครื่องให้) · ต้องรู้ customer uid จึงดึงจาก admin/assets
  CreateWr = async () => {
    const { data } = this.state;
    const asset = data.asset;
    if (asset.has_open_work_order && !window.confirm(t("ah_dup_confirm"))) return;
    this.setState({ creating_wr: true });
    loading(true);
    const result = await GET("admin/assets", { uid: asset.uid });
    loading(false);
    this.setState({ creating_wr: false });
    const full = result?.status ? result.data : null;
    const params = new URLSearchParams({ prefill: "1", asset_uid: asset.uid });
    const department = full?.department?.uid || asset.department?.uid;
    if (department) params.set("department_uid", department);
    if (full?.customer?.uid) params.set("customer_uid", full.customer.uid);
    window.location.href = `/ad/work-requests?${params.toString()}`;
  };

  // เปิด PDF ใน tab ใหม่ - เปิดหน้าต่างก่อนรอโหลด กัน popup blocker
  OpenServiceReport = async (event, report) => {
    const key = `${event.key}:${report.visit_uid}`;
    const win = window.open("", "_blank");
    this.setState({ opening_report: key });
    const result = await GET_FILE(String(report.pdf_path || "").replace(/^\/+/, ""));
    this.setState({ opening_report: "" });
    if (result?.status && result.blob) {
      const url = URL.createObjectURL(result.blob);
      this.blob_urls.push(url);
      if (win) win.location.href = url;
      else window.open(url, "_blank");
      return;
    }
    if (win) win.close();
    alert("", "warning", t("warning"), result?.message || t("ah_file_failed"));
  };

  OpenGallery = async (event) => {
    const photos = event.photos || [];
    this.setState({ gallery: { title: event.number, items: photos.map((p) => ({ ...p, url: "" })), loading: true } });
    const items = await Promise.all(
      photos.map(async (p) => {
        const result = await GET_FILE(`admin/attachments/${encodeURIComponent(p.uid)}`);
        if (result?.status && result.blob) {
          const url = URL.createObjectURL(result.blob);
          this.blob_urls.push(url);
          return { ...p, url };
        }
        return { ...p, url: "", failed: true };
      })
    );
    this.setState((s) => (s.gallery ? { gallery: { ...s.gallery, items, loading: false } } : null));
  };

  ToggleExpand = (key) => this.setState((s) => ({ expanded: { ...s.expanded, [key]: !s.expanded[key] } }));

  // ---------------------------------------------------------------- render
  renderHeader(data) {
    const { asset, summary } = data;
    const { creating_wr } = this.state;
    const location = [asset.location?.name, asset.location?.address, asset.location?.floor_room, asset.location?.sub_district, asset.location?.district, asset.location?.province, asset.location?.zip_code].filter(Boolean).join(" ");
    const info = [
      [t("ah_d_customer"), asset.customer_name, asset.customer_code],
      [t("ah_d_location"), location || "-"],
      [t("ah_d_project"), asset.project ? [asset.project.code, asset.project.name].filter(Boolean).join(" ") : "-"],
      [t("ah_d_brand_model"), [asset.brand_name, asset.model_name].filter(Boolean).join(" · ") || "-", asset.part_number],
      [t("ah_d_install_date"), fmtDate(asset.install_date)],
      [t("ah_d_invoice"), asset.invoice_number || "-"],
      [t("ah_d_sales"), asset.sales_name || "-"],
      [t("ah_d_price"), asset.price ? fmtBaht(asset.price) : "-"],
    ];
    return (
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4" data-testid="ah-header">
        <div className="d-flex flex-wrap gap-3 align-items-start">
          <div className="ah-avatar">⚙️</div>
          <div className="flex-grow-1" style={{ minWidth: 240 }}>
            <h4 className="fw-bold text-dark mb-1" data-testid="ah-asset-name">{asset.product_name || "-"}</h4>
            <div className="text-secondary text-14" style={{ fontFamily: "monospace" }}>{asset.asset_code}{asset.serial_number ? ` · S/N ${asset.serial_number}` : ""}</div>
            <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
              <StatusBadge status={asset.status} />
              <WarrantyBadge warranty={asset.warranty} />
              {asset.department?.code ? <span className="ah-bd bu">{asset.department.code}</span> : null}
              {asset.department?.name ? <span className="text-12 text-secondary">{asset.department.name}</span> : null}
              {asset.has_open_work_order ? <OpenBadge count={summary.open_work_orders} /> : null}
            </div>
          </div>
          <div className="d-flex flex-wrap gap-2 ms-auto">
            <button type="button" className="btn btn-white border px-3 py-2 rounded-3" onClick={this.OpenAssetMaster} data-testid="ah-open-asset">{t("ah_btn_asset")}</button>
            {asset.status === "active" && this.canCreateWr ? (
              <button type="button" className="btn btn-primary px-3 py-2 fw-bold rounded-3" onClick={this.CreateWr} disabled={creating_wr} data-testid="ah-create-wr">＋ {t("ah_btn_wr")}</button>
            ) : null}
          </div>
        </div>
        <div className="ah-info">
          {info.map(([k, v, sub]) => (
            <div key={k}>
              <div className="k">{k}</div>
              <div className="v">{v || "-"}</div>
              {sub ? <div className="text-12 text-secondary">{sub}</div> : null}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderSummary(data) {
    const s = data.summary;
    const mtbf = s.mtbf_days === null || s.mtbf_days === undefined ? "–" : fill(t("ah_days_n"), { n: fmtInt(s.mtbf_days) });
    const tiles = [
      [fmtInt(s.total_events), t("ah_sum_total")],
      [fmtInt(s.repair_count), t("ah_sum_repairs")],
      [mtbf, t("ah_sum_mtbf")],
      [fmtBaht(s.parts_cost_company), t("ah_sum_company"), "#7B3BC7"],
      [fmtBaht(s.parts_cost_customer), t("ah_sum_customer"), "#C25E06"],
    ];
    return (
      <div className="row g-3 mb-4">
        <div className="col-lg-6">
          <div className="bg-white rounded-4 shadow-sm p-4 h-100">
            <h6 className="fw-bold text-dark mb-3">🛡️ {t("ah_warranty_history")}</h6>
            <WarrantyBars items={data.warranty_history} />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="bg-white rounded-4 shadow-sm p-4 h-100">
            <h6 className="fw-bold text-dark mb-3 d-flex">📊 {t("ah_summary")}<span className="text-12 text-secondary fw-normal ms-auto">{t("ah_summary_lifetime")}</span></h6>
            <div className="ah-mk" data-testid="ah-summary">
              {tiles.map(([v, l, color]) => (
                <div key={l}><div className="v" style={color ? { color } : undefined}>{v}</div><div className="l">{l}</div></div>
              ))}
            </div>
            <div className="text-12 text-secondary mt-3">{t("ah_labor_note")}</div>
          </div>
        </div>
      </div>
    );
  }

  renderParts(event) {
    const parts = event.parts || [];
    if (!parts.length) return <div className="text-12 text-secondary">{t("ah_no_parts")}</div>;
    const money = (p, value) => {
      if (value === null || value === undefined) return "-";
      return fmtBaht(value);
    };
    return (
      <div className="table-responsive">
        <table className="table table-sm align-middle mb-0 ah-table" data-testid="ah-parts-table">
          <thead>
            <tr className="text-dark fw-bold border-bottom border-light">
              <th className="border-0">{t("ah_part_name")}</th>
              <th className="border-0 num">{t("ah_part_qty")}</th>
              <th className="border-0 num">{t("ah_part_unit")}</th>
              <th className="border-0 num">{t("ah_part_amount")}</th>
            </tr>
          </thead>
          <tbody>
            {parts.map((p, i) => (
              <tr key={i} className="border-bottom border-light">
                <td className="wrap">{p.name || "-"}<div className="sub">{p.part_number}{p.visit_sequence ? ` · ${fill(t("ah_visit_n"), { n: p.visit_sequence })}` : ""}</div></td>
                <td className="num">{fmtInt(p.quantity)}</td>
                <td className="num">{money(p, p.unit_price)}</td>
                <td className="num">{money(p, p.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderEvent(e) {
    const { expanded, opening_report } = this.state;
    const open = !!expanded[e.key];
    const pending = Number(e.parts_cost_pending_sap) || 0;
    const showCost = e.type !== "ins" && !e.is_open && e.parts_cost !== null && e.parts_cost !== undefined;
    const techs = (e.technicians || []).map((x) => x.name).filter(Boolean).join(", ");
    const reports = e.service_reports || [];
    const photos = e.photos || [];
    return (
      <div className="ah-ev" key={e.key} style={{ "--ec": TYPE_COLORS[e.type] || "#999" }} data-testid="ah-event">
        <div className="top">
          <span className="fw-semibold">{fmtDay(e.date)}</span>
          {e.source === "work_order" ? <a className="wo" href={`/ad/work-orders?search=${encodeURIComponent(e.number)}`} target="_blank" rel="noopener noreferrer">{e.number}</a> : <span className="wo">{e.number}</span>}
          <TypeBadge type={e.type} />
          <span className="text-12 text-secondary">{t(`ah_cov_${e.coverage}`)}</span>
          {e.is_open ? <span className="ah-bd open">● {t("ah_in_progress")}</span> : null}
          <span className="cost">
            {showCost ? fmtBaht(Math.max(0, e.parts_cost - pending)) : ""}
          </span>
        </div>
        {e.wr_number ? <div className="text-12 text-secondary mt-1">{e.wr_number}</div> : null}
        <div className="ev-grid">
          <div><div className="k">{t("ah_ev_symptom")}</div>{e.symptom || "-"}</div>
          <div><div className="k">{t("ah_ev_cause")}</div>{e.cause || "-"}</div>
          <div><div className="k">{t("ah_ev_resolution")}</div>{e.resolution || "-"}</div>
          <div><div className="k">{t("ah_ev_technician")}</div>{techs ? `👷 ${techs}` : "-"}</div>
          <div><div className="k">{t("ah_ev_time")}</div>{fmtMinutes(e.response_minutes)} / {fmtMinutes(e.duration_minutes)} {t("ah_hrs")}</div>
          <div><div className="k">{t("ah_ev_cost")}</div>{fmtBahtOrDash(e.labor_cost)} / {e.parts_cost === null || e.parts_cost === undefined ? "-" : fmtBaht(e.parts_cost)}</div>
        </div>
        <button type="button" className="ah-link-btn" onClick={() => this.ToggleExpand(e.key)} data-testid="ah-toggle">
          {t("ah_ev_more")} {open ? "▴" : "▾"}
        </button>
        {open ? (
          <div className="more" data-testid="ah-more">
            {this.renderParts(e)}
            <div className="d-flex flex-wrap gap-2 mt-3 align-items-center">
              {reports.map((r) => (
                <button key={r.visit_uid} type="button" className="btn btn-white border btn-sm rounded-3" disabled={opening_report === `${e.key}:${r.visit_uid}`} onClick={() => this.OpenServiceReport(e, r)} data-testid="ah-report-btn">
                  📄 {t("ah_service_report")}{reports.length > 1 ? ` #${r.visit_sequence}` : ""}
                </button>
              ))}
              {photos.length ? (
                <button type="button" className="btn btn-white border btn-sm rounded-3" onClick={() => this.OpenGallery(e)} data-testid="ah-photos-btn">📷 {fill(t("ah_photos_n"), { n: photos.length })}</button>
              ) : null}
              {e.signature?.signed ? <span className="ah-bd in">✍ {t("ah_signed")}{e.signature.signee_name ? ` · ${e.signature.signee_name}` : ""}</span> : null}
              {!reports.length && !photos.length && !e.signature?.signed ? <span className="text-12 text-secondary">{t("ah_no_docs")}</span> : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderTimeline(data) {
    const { type_filter } = this.state;
    const all = data.timeline || [];
    const list = type_filter === "all" ? all : all.filter((e) => e.type === type_filter);
    const countOf = (type) => all.filter((e) => e.type === type).length;
    const chips = [["all", t("ah_filter_all"), all.length], ...TIMELINE_TYPES.map((x) => [x, t(`ah_type_${x}`), countOf(x)])];
    return (
      <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
        <h6 className="fw-bold text-dark mb-3 d-flex">🔧 {t("ah_timeline")}<span className="text-12 text-secondary fw-normal ms-auto" data-testid="ah-timeline-count">{fill(t("ah_items_n"), { n: list.length })}</span></h6>
        <div className="ah-filters" data-testid="ah-type-filters">
          {chips.map(([key, label, n]) => (
            <button key={key} type="button" className={type_filter === key ? "on" : ""} onClick={() => this.setState({ type_filter: key })} data-testid={`ah-chip-${key}`}>{label} ({n})</button>
          ))}
        </div>
        {!list.length ? (
          <EmptyBox icon="🔧" title={t(all.length ? "ah_timeline_empty_type" : "ah_timeline_empty")} />
        ) : (
          <div className="ah-tl">{list.map((e) => this.renderEvent(e))}</div>
        )}
      </div>
    );
  }

  renderGallery() {
    const { gallery } = this.state;
    return (
      <Modal show={!!gallery} onHide={() => this.setState({ gallery: null })} centered size="lg" scrollable contentClassName="border-0 rounded-4 shadow-lg">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <h5 className="fw-bold mb-0 text-dark">📷 {gallery?.title}</h5>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white">
          {gallery?.loading ? <div className="text-secondary text-14 mb-2">{t("ah_loading_files")}</div> : null}
          <div className="ah-photo-grid" data-testid="ah-gallery">
            {(gallery?.items || []).map((p) => {
              if (p.failed) return <div key={p.uid} className="text-12 text-danger">{p.file_name} · {t("ah_file_failed")}</div>;
              if (!p.url) return <div key={p.uid} className="ah-skel" style={{ height: 130 }} />;
              if (p.file_type === "video") return <video key={p.uid} src={p.url} controls preload="metadata" />;
              if (p.file_type === "image") return <a key={p.uid} href={p.url} target="_blank" rel="noopener noreferrer"><img src={p.url} alt={p.file_name} /></a>;
              return <a key={p.uid} href={p.url} download={p.file_name} className="btn btn-white border">{p.file_name}</a>;
            })}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderBody() {
    const { data, fetching, error, forbidden, not_found } = this.state;
    if (forbidden) {
      return (
        <div className="bg-white rounded-4 shadow-sm p-5 text-center" data-testid="ah-forbidden">
          <h4 className="fw-bold text-dark">{t("ah_forbidden_asset")}</h4>
          <p className="text-secondary text-14 mb-3">{t("ah_forbidden_hint")}</p>
          <a className="btn btn-primary px-4 py-2 fw-bold rounded-3" href="/ad/asset-history-list">{t("ah_back_list")}</a>
        </div>
      );
    }
    if (not_found) {
      return (
        <div className="bg-white rounded-4 shadow-sm p-5 text-center" data-testid="ah-not-found">
          <h4 className="fw-bold text-dark">{t("ah_not_found")}</h4>
          <a className="btn btn-primary px-4 py-2 mt-3 fw-bold rounded-3" href="/ad/asset-history-list">{t("ah_back_list")}</a>
        </div>
      );
    }
    if (error) return <ErrorCard message={error} onRetry={this.Get} />;
    if (fetching || !data) return <Skeleton heights={[200, 160, 360]} />;
    return (
      <>
        {this.renderHeader(data)}
        {this.renderSummary(data)}
        {this.renderTimeline(data)}
      </>
    );
  }

  render() {
    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          <button type="button" className="btn btn-link p-0 mb-3 text-decoration-none fw-semibold" style={{ color: "#2A55E5" }} onClick={() => (document.referrer && window.history.length > 1 ? window.history.back() : (window.location.href = "/ad/asset-history-list"))} data-testid="ah-back">
            ‹ {t("ah_back_list")}
          </button>
          {this.renderBody()}
        </div>
        {this.renderGallery()}
      </div>
    );
  }
}
